import React, { Component } from "react";
import Popup from "@my-dld/components/Popup/Popup";
import Strings from "@my-dld/assets/strings";
import { JQModal } from "@my-dld/components/Popup/Utils";
import { Lookup } from "@eres/ejari-api/Entity";
import { LocaleUtil } from "@eres/core";

interface Props {
	terms?: Lookup[];
	onDismiss: () => void;
}

class TermsAndConditionsPopup extends Component<Props> {
	render() {
		const { terms } = this.props;
		return <Popup
			autoOpenMount={ true } id={ "TCTermsPopup" }
			modalMainContainer={ "modal fade" }
			modalSubContainer={ "modal-dialog modal-dialog-centered modal-lg" }
			title={ Strings.terms_and_conditions }
			showIcon={ false }
			onDismiss={ this.onDismiss } modalBodyContainer={ "" }>
			<div className="modal-body p-3">
				<ol className="list-unstyled terms-and-condition-list">
					{ terms && terms.map( ( term: Lookup ) => {
						return <React.Fragment key={ "tc_term_" + term.Id }>
							<li>{ LocaleUtil.getLocalValue( term ) }</li>
						</React.Fragment>;
					} ) }
				</ol>
			</div>
			<div className="modal-footer d-flex justify-content-center">
				<button type="button" className="btn btn-grey" onClick={ this.onDismiss }>{ Strings.close }</button>
			</div>
		</Popup>;
	}

	private onDismiss = () => {
		JQModal( "TCTermsPopup" ).hide();
		this.props.onDismiss();
	};
}

export default TermsAndConditionsPopup;
